import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {GameCenterWidgetFetchHandler} from "./game-center-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {GameCenterWidgetPopulateDataHandler} from "./game-center-widget.populate-data-handler";
import {WidgetLoadedEventHandler} from "../../../core/handlers/widget-loaded-event.handler";
import {GameCenterWidgetTabChangeHandler} from "./game-center-widget.tab-change.handler";
import {GameCenterWidgetLivePenaltiesPopupClickHandler} from "./game-center-widget.live-penalties-popup-click.handler";

export class GameCenterWidgetHandlers extends HandlerList {

  static injectables = [
    GameCenterWidgetFetchHandler,
    GameCenterWidgetPopulateDataHandler,
    GameCenterWidgetTabChangeHandler,
    GameCenterWidgetLivePenaltiesPopupClickHandler,
    WidgetLoadedEventHandler,
    TimingHandler
  ];

  constructor(
    gameCenterWidgetFetchHandler: GameCenterWidgetFetchHandler,
    gameCenterWidgetPopulateDataHandler: GameCenterWidgetPopulateDataHandler,
    gameCenterWidgetTabChangeHandler: GameCenterWidgetTabChangeHandler,
    gameCenterWidgetLivePenaltiesPopupClickHandler: GameCenterWidgetLivePenaltiesPopupClickHandler,
    widgetLoadedEventHandler: WidgetLoadedEventHandler,
    timingHandler: TimingHandler
  ) {
    super();

    [
      gameCenterWidgetFetchHandler,
      gameCenterWidgetPopulateDataHandler,
      gameCenterWidgetTabChangeHandler,
      gameCenterWidgetLivePenaltiesPopupClickHandler,
      widgetLoadedEventHandler,
      timingHandler
    ].forEach(handler => this.add(handler));
  }
}
